export const Sections: any = {
  BUSINESS: 'business',
  CONSUMER: 'consumer',
};

export default Sections;
